// extracted by mini-css-extract-plugin
export default {"image":"CommentContext-module__image--CRQM_","highlight":"CommentContext-module__highlight--CEQRt"};